/* ════════════════════════════════════════════════════════════
   حِكَم الدراسة

   كانت حكمة واحدة ثابتة في الصفحة الرئيسية — يراها الزائر نفسها كل
   مرّة، فتفقد أثرها بعد ثانية ويصير المكان زينة ميّتة.

   القائمة هنا مصدر واحد يتغذّى منه المكانان (الرئيسية والمخطّط)، فلا
   تتفرّق الحِكَم بين الصفحات ولا تُكتب مرّتين.

   كلّها عملية لا شعارات: تصف **سلوكاً يستطيع التلميذ فعله اليوم**،
   لأنّ حكمة لا تُترجَم إلى فعل لا تفيد تلميذ بكالوريا.
════════════════════════════════════════════════════════════ */

export const STUDY_QUOTES: { text: string; hint: string }[] = [
  { text: "النجاح هو مجموع جهودٍ صغيرة تتكرّر كل يوم",
    hint: "ابدأ بمراجعة 25 دقيقة الآن — خطوة صغيرة تصنع الفرق." },
  { text: "ساعة تركيز أفضل من خمس ساعات تشتّت",
    hint: "أغلق الإشعارات، واجعل الهاتف في غرفة أخرى." },
  { text: "ابدأ بالأصعب وأنت في قمّة نشاطك",
    hint: "أوّل ساعة بعد الاستيقاظ هي أثمن ما في يومك." },
  { text: "المراجعة المنتظمة تهزم الحفظ المتأخّر",
    hint: "راجع درس اليوم غداً، ثم بعد أسبوع — يثبت في الذاكرة." },
  { text: "الدرس الذي تشرحه لغيرك هو الدرس الذي فهمته",
    hint: "اشرح آخر درس لزميل، أو بصوت عالٍ لنفسك." },
  { text: "الخطأ في التمرين أرخص من الخطأ في البكالوريا",
    hint: "حلّ تمريناً واحداً بلا حلّ أمامك، ثم صحّح." },
  { text: "لا تقِس يومك بعدد الساعات بل بما فهمته",
    hint: "اكتب في سطر واحد ما تعلّمته اليوم." },
  { text: "التمرين المحلول مرّتين خير من عشرة قرأتها",
    hint: "أعد حلّ تمرين الأمس دون النظر إلى الحلّ." },
  { text: "من نظّم وقته ضاعف عمره",
    hint: "اكتب ثلاث مهامّ للغد قبل أن تنام." },
  { text: "الانقطاع القصير المنتظم يحمي التركيز الطويل",
    hint: "25 دقيقة عمل ثم 5 راحة — كرّرها أربع مرّات." },
  { text: "أصعب خطوة هي الجلوس إلى الطاولة",
    hint: "اتّفق مع نفسك على خمس دقائق فقط — ستكمل." },
  { text: "ما لا تكتبه تنساه",
    hint: "لخّص كل درس في بطاقة مراجعة واحدة." },
];

/**
 * حكمة اليوم — تتغيّر يومياً وتبقى ثابتة خلال اليوم نفسه.
 *
 * لماذا لا نستعمل عشوائياً محضاً: العشوائي يتبدّل مع كل إعادة تصيير،
 * فترتجف الحكمة أمام عين الزائر. والاعتماد على اليوم يجعلها مستقرّة
 * للجميع ويمنع اختلاف الخادم عن المتصفّح (Hydration mismatch).
 */
export function quoteOfDay(offset = 0): { text: string; hint: string } {
  const day = Math.floor(Date.now() / 86_400_000);
  const i = (((day + offset) % STUDY_QUOTES.length) + STUDY_QUOTES.length) % STUDY_QUOTES.length;
  return STUDY_QUOTES[i] ?? STUDY_QUOTES[0];
}

/**
 * حكمة تتغيّر مع **كل زيارة** — وهذا ما طلبتَه.
 *
 * `quoteOfDay` تثبت يوماً كاملاً، فيرى الزائر نفس الحكمة في كل صفحة
 * ويظنّها واحدة ثابتة. هذه تتقدّم عدّاداً محفوظاً في الجلسة، فتتغيّر
 * عند كل دخول وتبقى ثابتة أثناء التنقّل في نفس الجلسة — فلا ترتجف مع
 * كل إعادة تصيير ولا تختلف بين الخادم والمتصفّح.
 */
export function nextQuote(): { text: string; hint: string } {
  const KEY = "bz-quote-i";
  let i = 0;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw === null) {
      // أوّل زيارة في الجلسة: نبدأ من موضع عشوائي فلا يرى الجميع الأولى
      i = Math.floor(Math.random() * STUDY_QUOTES.length);
    } else {
      i = (Number(raw) + 1) % STUDY_QUOTES.length;
    }
    sessionStorage.setItem(KEY, String(i));
  } catch {
    // تخزين الجلسة قد يكون معطّلاً — نرجع إلى حكمة اليوم بدل الانهيار
    return quoteOfDay();
  }
  return STUDY_QUOTES[i] ?? STUDY_QUOTES[0];
}
